'use client'

import { useTranslations } from '@/lib/next-shim'

import { useSession } from '@/shared/ui/providers/AuthSessionProvider'
import { useGetMyInfosQuery } from '@/core/graphql/hooks'
import { useIsFranceMode } from '@/hooks/useIsFranceMode'

import { useCompleteProfileForm } from '../model/completeProfileForm'
import { useCompleteProfileRedirects } from '../model/useCompleteProfileRedirects'
import { useSubmitCompleteProfile } from '../model/useSubmitCompleteProfile'
import { CompleteProfileForm } from './CompleteProfileForm'

export function CompleteProfilePage() {
  const t = useTranslations()
  const { status } = useSession()
  const isFrance = useIsFranceMode()

  const { data, loading: queryLoading } = useGetMyInfosQuery({ skip: status !== 'authenticated' })
  const patient = data?.myInfos

  const { control, handleSubmit } = useCompleteProfileForm({ patient, isFrance })
  const { onSubmit, saving, saveError } = useSubmitCompleteProfile()

  useCompleteProfileRedirects({ status, patient, isFrance })

  if (status === 'loading' || queryLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-blue-400 border-t-white" />
      </div>
    )
  }

  if (status !== 'authenticated') return null

  return (
    <div className="flex items-start justify-center min-h-screen bg-white sm:bg-gray-50 py-8">
      <div className="w-full sm:w-[480px] bg-white sm:shadow rounded-lg p-6 sm:p-8 space-y-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">{t('page.CompleteProfile.title')}</h2>
          <p className="mt-1 text-sm text-gray-500">{t('page.CompleteProfile.subtitle')}</p>
        </div>

        {patient?.userInfo && (
          <div className="text-sm text-gray-600">
            <p className="font-medium">
              {patient.userInfo.name} {patient.userInfo.surname}
            </p>
            <p>{patient.email}</p>
          </div>
        )}

        {saveError && (
          <div className="p-4 text-sm text-red-700 bg-red-100 rounded-lg" role="alert">
            {saveError}
          </div>
        )}

        <CompleteProfileForm control={control} onSubmit={handleSubmit(onSubmit)} saving={saving} isFrance={isFrance} />
      </div>
    </div>
  )
}
